// extracted by mini-css-extract-plugin
module.exports = {"heroSection":"Overview_heroSection__T6_6O","discBlurbSection":"Overview_discBlurbSection__aGaCD"};